package landing.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shadow
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.lifecycle.viewmodel.compose.viewModel
import landing.model.ComingSoonModel
import landing.model.state.SloganPagerState
import loadResourceImage
import loadResourceVector
import logD
import theme.trueMatchTypography
import truematchmp.composeapp.generated.resources.Res
import truematchmp.composeapp.generated.resources.background
import truematchmp.composeapp.generated.resources.ic_android_black_24dp
import truematchmp.composeapp.generated.resources.ic_ios

@Composable
fun ComingSoonApp() {
    val viewModel = viewModel { ComingSoonModel() }
    MaterialTheme(
        typography = trueMatchTypography,
    ) {
        val sloganState by viewModel.uiState.collectAsState()
        ComingSoonScreen(
            state = sloganState,
            onClick = viewModel::onClick
        )
    }
}

@Composable
fun ComingSoonScreen(
    state: SloganPagerState,
    onClick: () -> Unit = {},
    modifier: Modifier = Modifier
) {
    logD("nextPage: ${state.nextPage}")
    Image(
        modifier = Modifier.fillMaxSize(),
        painter = loadResourceImage(Res.drawable.background),
        contentDescription = "",
        contentScale = ContentScale.Crop
    )
    Column(
        modifier = modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.SpaceAround
    ) {
        ElevatedCard(
            elevation = CardDefaults.cardElevation(
                defaultElevation = 6.dp
            ),
            modifier = Modifier
                .padding(16.dp)
                .weight(1f, true)
                .aspectRatio(.60f)
                .clickable(
                    onClick = onClick
                )
        ) {
            SloganPager(
                sloganPagerState = state,
                onReachEnd = {},
            )
        }
        ComingSooBottom(
            modifier = Modifier.padding(top = 16.dp)
        )
    }
}

@Composable
fun ComingSooBottom(
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        ComingSoonText(
            modifier = Modifier
        )
        PlatformsRow(
            modifier = Modifier
        )
        LinksPanel(
            modifier = Modifier,
        )
    }
}

@Composable
fun ComingSoonText(
    modifier: Modifier = Modifier
) {
    Text(
        modifier = modifier,
        text = "Coming Soon",
        fontWeight = FontWeight.Bold,
        style = MaterialTheme.typography.headlineMedium.copy(
            shadow = Shadow(
                color = Color.Black,
                offset = Offset(5f, 5f),
                blurRadius = 10f
            )
        ),
        textAlign = TextAlign.Center,
        color = Color.Black
    )
}

@Composable
fun PlatformsRow(
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(30.dp),
    ) {
        Image(
            modifier = Modifier.size(60.dp),
            imageVector = loadResourceVector(Res.drawable.ic_ios),
            contentDescription = null,
        )
        Image(
            modifier = Modifier.size(60.dp),
            imageVector = loadResourceVector(Res.drawable.ic_android_black_24dp),
            contentDescription = null,
        )
    }
}
